import React from 'react';
import Box from 'v2/components/UI/Box';
import Text from 'v2/components/UI/Text';
import RenderGraphBar from '../../UI/BarChart';
import Icon from 'v2/components/Icon';
import Select from 'v2/components/Select';
import MultiSelectAll from 'components/MultiSelect';
import useHealthAnalysis from './hooks/useHealthAnalysis';
import LineChart from '../../UI/LineChart';

const HealthAnalysis: React.FC = () => {
  const {
    optionsParameters,
    optionsnNurseries,
    selectedNurseries,
    selectedParameters,

    setSelectedParameters,
    handleSelectedInputNurseries,
  } = useHealthAnalysis();

  const renderTextEmptyMessageOrGraph = () => {
    if (optionsnNurseries.length === 2) {
      return (
        <Text fontSize={16} fontWeight={700} color="#5f1300">
          Nenhum dado encontrado
        </Text>
      );
    }
    if (selectedParameters?.length === 0) {
      return (
        <Text fontSize={16} fontWeight={700} color="#5f1300">
          Selecione ao menos um parâmetro
        </Text>
      );
    }
    return <LineChart data={selectedParameters || []} />;
  };

  return (
    <Box
      flexDirection="column"
      gap={30}
      padding={30}
      background="#fff"
      borderRadius={18}
    >
      <Box gap={10} alignItems="center">
        <Icon iconName="BiotechOutlined" htmlColor="#005f47" size={30} />
        <Text fontSize={24} fontWeight={700} color="#005f47">
          Análise de Saúde
        </Text>
      </Box>

      <Box gap={20}>
        <Select
          backgroundColor="#b7ffbd"
          options={optionsnNurseries}
          value={selectedNurseries}
          labelId="nurseries-label"
          selectId="nurseries-id"
          label="Viveiros"
          onChange={handleSelectedInputNurseries}
          id="ponds"
        />

        <Box>
          <MultiSelectAll
            label="Parâmetros"
            id="parameters"
            labelOption="name"
            allSelected={
              optionsParameters?.length === selectedParameters?.length
            }
            onChange={setSelectedParameters}
            options={optionsParameters}
            value={selectedParameters}
            error={false}
            helperText={false}
            renderOptionLabel={false}
            labelSelectAllButtonFilterOptions={false}
            labelCustomRenderOption={false}
          />
        </Box>
      </Box>
      {renderTextEmptyMessageOrGraph()}
    </Box>
  );
};

export default HealthAnalysis;
